import React from "react";
import "./complianceAppPage.scss";
import { Helmet } from "react-helmet";

import IncidentReporting from "../assets/images/ComplainceApp_IncidentReporting.svg";
import Notifications from "../assets/images/ComplainceApp_Notifications.svg";
import PreUse from "../assets/images/ComplainceApp_PreUse.svg";
import MainImg from "../assets/images/ComplainceApp_MainImg.svg";
import { ContactForm } from "../components/ContactForm";
import { gsap } from "gsap";

import MetaImg from "../assets/images/MetaImg-3.png";

export function ComplianceAppPage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);

    // const tl = gsap.timeline({
    //   defaults: { duration: 0.5, ease: "power1.out" },
    // });

    // tl.from(".complainceHeaderContent", { opacity: 0, y: -20 }) // Reduced y movement
    //   .from(".complianceDescriptionContainer", { opacity: 0, y: 20 }, "-=0.2") // Reduced y movement
    //   .from(".complianceGidContent", { opacity: 0, y: 20 }, "-=0.2") // Reduced y movement
    //   .from(
    //     [".complianceGidText", ".complianceGridImg"],
    //     { opacity: 0, y: 10, stagger: 0.1 },
    //     "-=0.2"
    //   ); // Reduced y movement

    const animateOnScroll = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;

          gsap.from(target, {
            opacity: 0,
            y: 20,
            duration: 0.5,
            ease: "power1.out",
            stagger: 5,
          });

          observer.unobserve(target);
        }
      });
    };

    const observer = new IntersectionObserver(animateOnScroll, {
      threshold: 0.1,
    });

    const elementsToAnimate = [
      ".complianceHeaderTextContainer",
      ".complainceHeaderMainImg",
      ".complianceDescriptionContainer",
      ".complianceGidContent",
      ".complianceGidText",
      ".complianceGridImg",
    ];

    elementsToAnimate.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => observer.observe(element));
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const metaKeywords =
    "compliance software, safety compliance, regulatory compliance, safety program management, compliance tracking, compliance reminders, real-time reporting, workplace safety, compliance automation, regulatory tracking, compliance management system, safety audits, safety verification, compliance deadlines, compliance confidence, compliance monitoring, compliance solutions";

  return (
    <>
      <Helmet>
        <title>Compliance App | Alpaca Systems</title>
        <meta
          name="description"
          content="Alpaca Compliance Software streamlines safety compliance with automated tracking, proactive reminders, and real-time reporting for full regulatory confidence."
        />
        const metaKeywords =
        <meta name="keywords" content={metaKeywords} />
        <meta name="author" content="Alpaca Systems" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/* Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="Compliance Software" />
        <meta
          property="og:description"
          content="Alpaca Compliance Software streamlines safety compliance with automated tracking, proactive reminders, and real-time reporting for full regulatory confidence."
        />
        <meta property="og:image" content={MetaImg} />
        <meta
          property="og:url"
          content="https://alpacasys.com/modules/compliance-app"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Alpaca Systems" />
        <meta
          name="twitter:description"
          content="Alpaca Compliance Software streamlines safety compliance with automated tracking, proactive reminders, and real-time reporting for full regulatory confidence."
        />
        <meta name="twitter:image" content={MetaImg} />
        <meta name="twitter:site" content="@YourTwitterHandle" />
        {/* Canonical URL (Prevents duplicate content issues) */}
        <link
          rel="canonical"
          href="https://alpacasys.com/modules/compliance-app"
        />
        {/* Additional SEO Enhancements */}
      </Helmet>

      <section className="complainceHeaderContent">
        <div className="complianceHeaderTextContainer">
          <h1 className="mainSubhead centre white">
            Compliance Software that integrates with your Company’s existing
            Safety Program
          </h1>
        </div>
        <img src={MainImg} alt="" className="complainceHeaderMainImg" />
      </section>

      <section className="complainceBodyContent">
        <div className="complianceDescriptionContainer">
          <h2 className="mainSubhead centre">
            What is Alpaca Compliance Software
          </h2>
          <p className="body-text">
            Alpaca Compliance Software simplifies the process of capturing and
            organizing the key inputs required by your safety program, ensuring
            full compliance with all regulations. With proactive reminders for
            upcoming re-verifications, it helps your team stay ahead of
            deadlines. Its robust reporting delivers a clear, real-time overview
            of your company’s compliance status, giving you the confidence to
            manage every aspect of your safety program effectively.
          </p>
        </div>

        <div className="complianceGidContent">
          <div className="complianceGidText">
            <h4 className="smallSubhead">Notification System</h4>
            <p className="body-text left">
              Alpaca Compliance Software simplifies the process of capturing and
            </p>
          </div>
          <div className="complianceGridImg">
            <img src={Notifications} alt="" />
          </div>
          <div className="complianceGridImg">
            <img src={PreUse} alt="" />
          </div>

          <div className="complianceGidText reverseGrid">
            <h4 className="smallSubhead">Pre-use Inspections</h4>
            <p className="body-text left">
              Our Pre-Use Inspection System simplifies equipment checks with an
              easy-to-use form. Users quickly answer yes/no questions to ensure
              everything is in safe working condition before use.
            </p>
          </div>

          <div className="complianceGidText">
            <h4 className="smallSubhead">Incident and Hazard Reporting</h4>
            <p className="body-text left">
              Effortlessly track and manage workplace incidents with our
              intuitive reporting dashboard. With an easy-to-use submission
              form, your team can quickly report incidents, ensuring compliance
              and improving safety across your organization.
            </p>
          </div>
          <div className="complianceGridImg">
            <img src={IncidentReporting} alt="" />
          </div>
        </div>
      </section>

      <ContactForm />
    </>
  );
}
